import React from "react";
import appConfig from "../../config/app.config";



import "./no-product-found.component.scss";

const NoProductFound = () => {
  return (
    <div className="no-product-found">
       <div > <img src={appConfig.staticAssetsUrl+"no-product-found-image.svg"} /></div>
      <span>No Product Found!</span>
    </div>
  );
};

export default NoProductFound;
